import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { iRootState } from "../../../rematch/store";
import { propertyDefinitionsOfFilterPanelsForViewsSelector } from "../../../rematch/selectors/selectors";
import IMFilesPropertyDefinition from "../../../backend/interfaces/mfiles/IMFilesPropertyDefinition";
import { ownPropertiesToFilter } from "../../../backend/helpers/filteringHelper";
import { useTranslation } from "react-i18next";
import { translatePropertyDefName } from "../../../backend/helpers/translationHelpers"
import sortBy from "lodash/sortBy";
import Select from "react-select";

// TODO: put this in a grid item

// TODO: move this to common interface
interface SelectOption {
  value: string;
  label: string;
}

export interface ISelectedProperty {
  isOwnProperty: boolean;
  name: string;
  propertyIdOrName: number | string;
}

interface IProps {
  viewIndex: number;
  selectedMfilesPropertyIdOrOwnPropertyName: number | string;
  onChange: (property: number | string) => void;

  // From connect()
  propertyDefinitionsOfViews: IMFilesPropertyDefinition[][];
}

const FilterPropertySelect = (props: IProps) => {

  const { t } = useTranslation();

  const [propertyList, setPropertyList]                = useState<ISelectedProperty[]>([]);
  const [filteredPropertyList, setFilteredPropertyList] = useState<ISelectedProperty[]>([]);
  const [searchTerm, _setSearchTerm]                   = useState<string>("");
  const [selectedIndex, setSelectedIndex]              = useState<number>();
  const [selectedProperty, setSelectedProperty]        = useState<SelectOption>();
  
  const [propertyOptions, setPropertyOptions] = useState<SelectOption[]>([]);

  const onSelect = ([selectedIdx, ..._]) => {
    props.onChange(filteredPropertyList[selectedIdx]?.propertyIdOrName ?? null);
  };

  useEffect(() => {

    const index = filteredPropertyList.findIndex(p => p.propertyIdOrName === props.selectedMfilesPropertyIdOrOwnPropertyName);

    if ( index !== selectedIndex ) {

      if ( index === -1 ) {
        setSelectedIndex( null );
        setSelectedProperty( null );
      } else {
        setSelectedIndex( index );
        setSelectedProperty( propertyOptions[index] );
      }
    }

  }, [props.selectedMfilesPropertyIdOrOwnPropertyName, filteredPropertyList, propertyOptions, selectedIndex])

  useEffect(() => {
    setPropertyList(
      sortBy(
        ownPropertiesToFilter.map<ISelectedProperty>(i => 
          ({isOwnProperty: true, name: t(i.displayName), propertyIdOrName: i.ownPropertyName}))
          .concat(
            props.propertyDefinitionsOfViews[props.viewIndex].map<ISelectedProperty>(p => 
              ({isOwnProperty: false, name: translatePropertyDefName(p.ID, p.Name), propertyIdOrName: p.ID})))
        , p => p.name)
    );

  }, [t, props.viewIndex, props.propertyDefinitionsOfViews]);

  useEffect(() => {

    if( searchTerm === null || searchTerm === "" ) {
      setFilteredPropertyList(propertyList);
    } else {
      setFilteredPropertyList(propertyList.filter(i => i.name?.toLowerCase()?.includes(searchTerm.toLowerCase())))
    }

    let propOptions = [];

    propertyList.forEach((prop: ISelectedProperty) => {
      propOptions.push( { value: prop.propertyIdOrName.toString(), label: prop.name } );
    });

    setPropertyOptions(propOptions);

  }, [propertyList, searchTerm]);

  return (
    <div>
      <Select
        options={propertyOptions}
        value={selectedProperty}
        isMulti={false}
        placeholder={`${t("command.select")}...`}
        styles={{ 
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), 
          control: (baseStyles, state) => ({...baseStyles, borderColor: state.isFocused ? 'grey' : 'red', background: 'white', color: 'black', border: '1px solid #78899a', borderRadius: 'none'}),
          multiValue: (base) => ({...base, fontSize: "16px", color: 'black'}), //multiValue child has 85% font
          option: provided => ({...provided, color: 'black'}),
        }}
        onChange={(e) => {
          const ind = propertyOptions.findIndex((value: SelectOption) => value.value === e.value)
          onSelect ([ind] )
        }}
      />
    </div>
  );
};

export default connect((state: iRootState) => ({
  propertyDefinitionsOfViews: propertyDefinitionsOfFilterPanelsForViewsSelector(state as never),
}))(FilterPropertySelect);
